import { useRef } from 'react';

/**
 * Returns the actual previous value despite the component re-rendering.
 * @param value The value to track.
 * @returns The previous value.
 */
function usePreviousPersistent<T>(value: T): T {
  const ref = useRef({
    value,
    prev: null,
  });

  const current = ref.current.value;

  if (value !== current) {
    ref.current = {
      value,
      prev: current,
    };
  }

  // return the previous value only
  return ref.current.prev;
}

export default usePreviousPersistent;
